module.exports = __webpack_public_path__ + "img/bg_classify3.67b771ea.png";